import React from "react";

const UserDetails = () => {
  return (
    <div>
      <h1 className="text-black">This is User Details page</h1>
      <h2 className="text-red-400 text-xl">Working is in progess.....</h2>
    </div>
  );
};

export default UserDetails;
